import { Box, Container, Typography } from "@mui/material";
import React from "react";

function Footer() {
  return (
    <Box py={2}>
      <Container>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Saira Semi Condensed",
            fontSize: { xs: "18px", sm: "22px" },
            textAlign: "center",
            fontWeight: "400",
            color: "#000000",
          }}
        >
          Copyright © 2024 BITGROK AI. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
